<script setup>
const props = defineProps({
  primaryColor: {
    type: String,
    required: false,
    default: "#007F80",
  },
  secondaryColor: {
    type: String,
    required: false,
    default: "#E3F8F8",
  },
});
</script>

<template>
  <div
    :class="`bg-[${props.secondaryColor}] rounded-full h-[163px] w-[163px] flex justify-center items-center`"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="52"
      height="66"
      viewBox="0 0 52 66"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 60V6C0 2.7 2.7 0.03 6 0.03L36 0C39.3 0 42 2.7 42 6V18H36V15H6V51H36V48H42V60C42 63.3 39.3 66 36 66H6C2.7 66 0 63.3 0 60ZM36 60V57H6V60H36ZM6 6H36V9H6V6ZM51.6 25.65L47.4 21.45L32.25 36.6L25.2 29.55L21 33.75L32.25 45L51.6 25.65Z"
        :fill="props.primaryColor"
      />
    </svg>
  </div>
</template>
